import {
  orderEntryCollection,
  orderGuideItemCollection,
} from '@/experiences/sales-portal/domain/ordering/screens/order-entry/blocs/collections/order-entry-collection';
import {
  OrderEntryPriceEditDisplayHeader,
  SalesPortalOrderEntryTable_OrderEntryItemFieldsFragment,
} from '@/types';
import { SalesRepConfig } from '@domain/configuration/types';
import { transformOrderEntryItem } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/blocs/transformers/order-entry-table-transformers';
import { usePricingStore } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/blocs/stores/pricing-store';

/**
 * Inserts freshly fetched order-entry rows into the TanStack DB collections
 * (skipping ids already present, so concurrent fetches don't double-insert) and
 * syncs their PriceEditor instances.
 */
export const insertAndSyncOrderEntryItems = (
  rawItems: SalesPortalOrderEntryTable_OrderEntryItemFieldsFragment[],
  priceEditDisplayHeaders: OrderEntryPriceEditDisplayHeader[],
  salesRepConfig: SalesRepConfig | null,
): void => {
  const newRawItems = rawItems.filter(
    (item) => !orderGuideItemCollection.get(item.variant_pack_id),
  );
  if (newRawItems.length > 0) {
    const nextSortRank = orderEntryCollection.size;
    orderGuideItemCollection.insert(newRawItems);
    orderEntryCollection.insert(
      newRawItems.map((item, index) =>
        transformOrderEntryItem(
          item,
          nextSortRank + index,
          priceEditDisplayHeaders,
        ),
      ),
    );
  }

  if (salesRepConfig && rawItems.length > 0) {
    usePricingStore.getState().syncEditors(rawItems, salesRepConfig);
  }
};
